module.exports = __webpack_public_path__ + "images/emoji/jp.e4d222bb672b4a429094.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/jp.png
// module id = JcDi
// module chunks = 13